// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --broken-image-degree: -35deg;
}

:host([dir=rtl]) {
  --broken-image-degree: 35deg;
}

.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-default);
}
.ids-calendar-event:not([color]):not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not([color]):focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not([color]) {
  background-color: var(--ids-calendar-event-color-background);
}

.ids-calendar-event:not(:has(.pending))[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-primary);
}
.ids-calendar-event:not(:has(.pending))[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=primary]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=primary] {
  background-color: var(--ids-calendar-event-color-background-accent-primary);
  color: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-blue);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=blue]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-orange);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=orange]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-neutral);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=neutral]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-purple);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=purple]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event:not(:has(.pending))[color=green]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-green);
}
.ids-calendar-event:not(:has(.pending))[color=green]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=green]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event:not(:has(.pending))[color=red]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-red);
}
.ids-calendar-event:not(:has(.pending))[color=red]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=red]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 5px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-turqoise);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends):focus {
  border-inline-start-color: var(--ids-calendar-event-color-border-focus);
}
.ids-calendar-event:not(:has(.pending))[color=teal]:focus {
  box-shadow: var(--ids-shadow-20);
  border-color: var(--ids-calendar-event-color-border-focus);
  outline: none;
}
.ids-calendar-event:not(:has(.pending))[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}

.ids-calendar-event:has(.pending) {
  padding-inline-start: 4px;
}
.ids-calendar-event:has(.pending)[color=primary] {
  background-color: var(--ids-calendar-event-color-background-accent-primary);
  color: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event:has(.pending)[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-primary) 0, var(--ids-calendar-event-color-border-accent-primary) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event:has(.pending)[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-blue) 0, var(--ids-calendar-event-color-border-accent-blue) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event:has(.pending)[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-orange) 0, var(--ids-calendar-event-color-border-accent-orange) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event:has(.pending)[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-neutral) 0, var(--ids-calendar-event-color-border-accent-neutral) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event:has(.pending)[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-purple) 0, var(--ids-calendar-event-color-border-accent-purple) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event:has(.pending)[color=green]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-green) 0, var(--ids-calendar-event-color-border-accent-green) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event:has(.pending)[color=red]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-red) 0, var(--ids-calendar-event-color-border-accent-red) 4px, transparent 4px, transparent 7px);
}
.ids-calendar-event:has(.pending)[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}
.ids-calendar-event:has(.pending)[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends)::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-image: repeating-linear-gradient(var(--broken-image-degree), var(--ids-calendar-event-color-border-accent-turqoise) 0, var(--ids-calendar-event-color-border-accent-turqoise) 4px, transparent 4px, transparent 7px);
}

.ids-calendar-event {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  z-index: var(--ids-z-index-10);
  background: var(--ids-calendar-event-color-background);
  border: 1px solid transparent;
  border-radius: var(--ids-border-radius-xs);
  color: var(--ids-calendar-event-color-text);
  overflow: hidden;
  text-decoration: none;
}
.ids-calendar-event .container {
  width: 100%;
}
.ids-calendar-event .header {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.ids-calendar-event .header .icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-inline-end: 4px;
  gap: 4px;
  flex-shrink: 0;
  margin-inline-start: auto;
}
.ids-calendar-event .header .icons ids-tooltip {
  position: absolute;
}
.ids-calendar-event.standalone {
  display: block;
  position: relative;
  height: unset;
}
.ids-calendar-event .gap {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--ids-space-3xs) 5px;
}
.ids-calendar-event .gap ids-text {
  display: block;
  width: 100%;
  height: 100%;
}
.ids-calendar-event .calendar-event-icon {
  vertical-align: bottom;
  position: relative;
  margin-inline-end: 1px;
  margin-inline-start: -1px;
}
.ids-calendar-event .calendar-event-icon[icon=success-alert] {
  color: var(--ids-calendar-event-color-icon-success);
}
.ids-calendar-event .calendar-event-icon[icon=alert-alert] {
  color: var(--ids-calendar-event-color-icon-alert);
}
.ids-calendar-event .calendar-event-icon[icon=clock] {
  color: var(--ids-calendar-event-color-icon-clock);
}
.ids-calendar-event .calendar-event-icon[icon=pending] {
  color: var(--ids-calendar-event-color-icon-pending);
}
.ids-calendar-event .calendar-event-title {
  line-height: 14px;
}
.ids-calendar-event .calendar-event-title::part(text) {
  text-transform: initial;
}
.ids-calendar-event.is-cutoff {
  border-radius: 3px 3px 0 0;
}
.ids-calendar-event.is-ellipsis .calendar-event-content {
  white-space: nowrap;
}
.ids-calendar-event.reduced-padding .calendar-event-content {
  padding: 0 5px;
}
.ids-calendar-event.reduced-padding .calendar-event-title {
  position: relative;
  top: -1.6px;
}
.ids-calendar-event .calendar-event-content {
  padding: 2px 5px;
}

.ids-calendar-event.all-day {
  top: 1px;
}
.ids-calendar-event.all-day .calendar-event-time,
.ids-calendar-event.all-day .calendar-event-comments {
  display: none;
}
.ids-calendar-event.all-day.calendar-event-start, .ids-calendar-event.all-day.calendar-event-continue, .ids-calendar-event.all-day.calendar-event-ends {
  border-radius: 0;
}
.ids-calendar-event.all-day.calendar-event-start {
  border-start-start-radius: 3px;
  border-end-start-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue {
  width: calc(100% + 2px);
  margin-inline-start: -1px;
}
.ids-calendar-event.all-day.calendar-event-ends {
  border-end-end-radius: 3px;
  border-start-end-radius: 3px;
}
.ids-calendar-event.all-day.calendar-event-continue ids-icon, .ids-calendar-event.all-day.calendar-event-ends ids-icon {
  visibility: hidden;
}
.ids-calendar-event.all-day.calendar-event-continue .calendar-event-title, .ids-calendar-event.all-day.calendar-event-ends .calendar-event-title {
  color: var(--ids-color-transparent);
}

.ids-calendar-event.is-month-view {
  position: absolute;
  display: block;
}
.ids-calendar-event.is-month-view:not(.all-day) {
  width: calc(100% - 10px);
  margin: 0 5px;
}
.ids-calendar-event.is-month-view.calendar-event-start, .ids-calendar-event.is-month-view.calendar-event-continue, .ids-calendar-event.is-month-view.calendar-event-ends {
  width: calc(100% - 5px);
}
.ids-calendar-event.is-month-view.calendar-event-start {
  margin-inline-start: 5px;
}
.ids-calendar-event.is-month-view.calendar-event-continue {
  width: 100%;
  margin-inline-start: 0;
}
.ids-calendar-event.is-month-view.calendar-event-ends {
  margin-inline-end: 5px;
}
.ids-calendar-event.is-month-view.hidden {
  display: none;
}
.ids-calendar-event.is-month-view .calendar-event-content {
  padding: 2px 4px;
  display: flex;
  align-items: center;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-calendar/ids-calendar-event.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAGE;EACE,8BAAA;EACA,yEAiC2B;AAjC/B;AAEI;EACE,uEAAA;AAAN;AAIE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAFJ;AAwBA;EAGE,4DAAA;AAxBF;;AAbE;EACE,8BAAA;EACA,gFAwC6B;AAxBjC;AAdI;EACE,uEAAA;AAgBN;AAZE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAcJ;AAeE;EAGE,2EAAA;EACA,sDAAA;AAfJ;AA9BE;EACE,8BAAA;EACA,6EA+C6B;AAfjC;AA9BI;EACE,uEAAA;AAgCN;AA5BE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AA8BJ;AAME;EAGE,wEAAA;AANJ;AA7CE;EACE,8BAAA;EACA,+EAqD6B;AANjC;AA7CI;EACE,uEAAA;AA+CN;AA3CE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AA6CJ;AAHE;EAGE,0EAAA;AAGJ;AA5DE;EACE,8BAAA;EACA,gFA2D6B;AAGjC;AA5DI;EACE,uEAAA;AA8DN;AA1DE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AA4DJ;AAZE;EAGE,2EAAA;AAYJ;AA3EE;EACE,8BAAA;EACA,+EAiE6B;AAYjC;AA3EI;EACE,uEAAA;AA6EN;AAzEE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AA2EJ;AArBE;EAGE,0EAAA;AAqBJ;AA1FE;EACE,8BAAA;EACA,8EAuE6B;AAqBjC;AA1FI;EACE,uEAAA;AA4FN;AAxFE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AA0FJ;AA9BE;EAGE,yEAAA;AA8BJ;AAzGE;EACE,8BAAA;EACA,4EA6E6B;AA8BjC;AAzGI;EACE,uEAAA;AA2GN;AAvGE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAyGJ;AAvCE;EAGE,uEAAA;AAuCJ;AAxHE;EACE,8BAAA;EACA,iFAmF6B;AAuCjC;AAxHI;EACE,uEAAA;AA0HN;AAtHE;EACE,gCAAA;EACA,0DAAA;EACA,aAAA;AAwHJ;AAhDE;EAGE,4EAAA;AAgDJ;;AA5CA;EACE,yBAAA;AA+CF;AA7CE;EACE,2EAAA;EACA,sDAAA;AA+CJ;AA9HE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,6NAAA;AAgIJ;AAnDE;EACE,wEAAA;AAqDJ;AA1IE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,uNAAA;AA4IJ;AAzDE;EACE,0EAAA;AA2DJ;AAtJE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,2NAAA;AAwJJ;AA/DE;EACE,2EAAA;AAiEJ;AAlKE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,6NAAA;AAoKJ;AArEE;EACE,0EAAA;AAuEJ;AA9KE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,2NAAA;AAgLJ;AA3EE;EACE,yEAAA;AA6EJ;AA1LE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yNAAA;AA4LJ;AAjFE;EACE,uEAAA;AAmFJ;AAtME;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,qNAAA;AAwMJ;AAvFE;EACE,4EAAA;AAyFJ;AAlNE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,+NAAA;AAoNJ;;AA5FA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,sDAAA;EACA,6BAAA;EACA,0CAAA;EACA,2CAAA;EACA,gBAAA;EACA,qBAAA;AA+FF;AA7FE;EACE,WAAA;AA+FJ;AA5FE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AA8FJ;AA5FI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;AA8FN;AA5FM;EACE,kBAAA;AA8FR;AAzFE;EACE,cAAA;EACA,kBAAA;EACA,aAAA;AA2FJ;AAxFE;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AA0FJ;AAxFI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA0FN;AAtFE;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAwFJ;AAtFI;EACE,mDAAA;AAwFN;AArFI;EACE,iDAAA;AAuFN;AApFI;EACE,iDAAA;AAsFN;AAnFI;EACE,mDAAA;AAqFN;AAjFE;EACE,iBAAA;AAmFJ;AAjFI;EACE,uBAAA;AAmFN;AA9EE;EACE,0BAAA;AAgFJ;AA5EI;EACE,mBAAA;AA8EN;AAzEI;EACE,cAAA;AA2EN;AAxEI;EACE,kBAAA;EACA,WAAA;AA0EN;AAtEE;EACE,gBAAA;AAwEJ;;AAnEA;EACE,QAAA;AAsEF;AApEE;;EAEE,aAAA;AAsEJ;AAnEE;EAGE,gBAAA;AAmEJ;AA/DE;EACE,8BAAA;EACA,4BAAA;AAiEJ;AA9DE;EACE,uBAAA;EACA,yBAAA;AAgEJ;AA5DE;EACE,0BAAA;EACA,4BAAA;AA8DJ;AAzDI;EACE,kBAAA;AA2DN;AAxDI;EACE,mCAAA;AA0DN;;AApDA;EAGE,kBAAA;EACA,cAAA;AAqDF;AAnDE;EACE,wBAAA;EACA,aAAA;AAqDJ;AAlDE;EAGE,uBAAA;AAkDJ;AA/CE;EACE,wBAjBa;AAkEjB;AA9CE;EACE,WAAA;EACA,sBAAA;AAgDJ;AA7CE;EACE,sBA1Ba;AAyEjB;AA5CE;EACE,aAAA;AA8CJ;AA3CE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA6CJ","sourcesContent":[":host {\n  --broken-image-degree: -35deg;\n}\n\n:host([dir=\"rtl\"]) {\n  --broken-image-degree: 35deg;\n}\n\n@mixin event-border-accent($color) {\n  &:not(.calendar-event-continue):not(.calendar-event-ends) {\n    border-inline-start-width: 5px;\n    border-inline-start-color: $color;\n\n    &:focus {\n      border-inline-start-color: var(--ids-calendar-event-color-border-focus);\n    }\n  }\n\n  &:focus {\n    box-shadow: var(--ids-shadow-20);\n    border-color: var(--ids-calendar-event-color-border-focus);\n    outline: none;\n  }\n}\n\n@mixin event-broken-border-accent($color) {\n  &:not(.calendar-event-continue):not(.calendar-event-ends)::before {\n    content: '';\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    width: 4px;\n    height: 100%;\n    background-image: repeating-linear-gradient(var(--broken-image-degree),\n    $color 0, \n    $color 4px, \n    transparent 4px,\n    transparent 7px);\n  }\n}\n\n\n// Calendar Event Type Themes\n.ids-calendar-event:not([color]) {\n  @include event-border-accent(var(--ids-calendar-event-color-border-default));\n\n  background-color: var(--ids-calendar-event-color-background);\n}\n\n.ids-calendar-event:not(:has(.pending))  {\n  &[color='primary'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-primary));\n\n    background-color: var(--ids-calendar-event-color-background-accent-primary);\n    color: var(--ids-calendar-event-color-forecolor-light);\n  }\n\n  &[color='blue'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-blue));\n\n    background-color: var(--ids-calendar-event-color-background-accent-blue);\n  }\n\n  &[color='orange'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-orange));\n\n    background-color: var(--ids-calendar-event-color-background-accent-orange);\n  }\n\n  &[color='neutral'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-neutral));\n\n    background-color: var(--ids-calendar-event-color-background-accent-neutral);\n  }\n\n  &[color='purple'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-purple));\n\n    background-color: var(--ids-calendar-event-color-background-accent-purple);\n  }\n\n  &[color='green'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-green));\n\n    background-color: var(--ids-calendar-event-color-background-accent-green);\n  }\n\n  &[color='red'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-red));\n\n    background-color: var(--ids-calendar-event-color-background-accent-red);\n  }\n\n  &[color='teal'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-turqoise));\n\n    background-color: var(--ids-calendar-event-color-background-accent-turqoise);\n  }\n}\n\n.ids-calendar-event:has(.pending) { \n  padding-inline-start: 4px;\n\n  &[color='primary'] {\n    background-color: var(--ids-calendar-event-color-background-accent-primary);\n    color: var(--ids-calendar-event-color-forecolor-light);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-primary));\n  }\n\n  &[color='blue'] {\n    background-color: var(--ids-calendar-event-color-background-accent-blue);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-blue));\n  }\n  \n  &[color='orange'] {\n    background-color: var(--ids-calendar-event-color-background-accent-orange);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-orange));\n  }\n\n  &[color='neutral'] {\n    background-color: var(--ids-calendar-event-color-background-accent-neutral);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-neutral));\n  }\n\n  &[color='purple'] {\n    background-color: var(--ids-calendar-event-color-background-accent-purple);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-purple));\n  }\n\n  &[color='green'] {\n    background-color: var(--ids-calendar-event-color-background-accent-green);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-green));\n  }\n\n  &[color='red'] {\n    background-color: var(--ids-calendar-event-color-background-accent-red);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-red));\n  }\n\n  &[color='teal'] {\n    background-color: var(--ids-calendar-event-color-background-accent-turqoise);\n\n    @include event-broken-border-accent(var(--ids-calendar-event-color-border-accent-turqoise));\n  }\n}\n\n.ids-calendar-event {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  z-index: var(--ids-z-index-10);\n  background: var(--ids-calendar-event-color-background);\n  border: 1px solid transparent;\n  border-radius: var(--ids-border-radius-xs);\n  color: var(--ids-calendar-event-color-text);\n  overflow: hidden;\n  text-decoration: none;\n\n  .container {\n    width: 100%;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n\n    .icons {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      padding-inline-end: 4px;\n      gap: 4px;\n      flex-shrink: 0;\n      margin-inline-start: auto;\n\n      ids-tooltip {\n        position: absolute;\n      }\n    }\n  }\n\n  &.standalone {\n    display: block;\n    position: relative;\n    height: unset;\n  }\n\n  .gap {\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    padding: var(--ids-space-3xs) 5px;\n\n    ids-text {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .calendar-event-icon {\n    vertical-align: bottom;\n    position: relative;\n    margin-inline-end: 1px;\n    margin-inline-start: -1px;\n\n    &[icon='success-alert'] {\n      color: var(--ids-calendar-event-color-icon-success);\n    }\n\n    &[icon='alert-alert'] {\n      color: var(--ids-calendar-event-color-icon-alert);\n    }\n\n    &[icon='clock'] {\n      color: var(--ids-calendar-event-color-icon-clock);\n    }\n\n    &[icon='pending'] {\n      color: var(--ids-calendar-event-color-icon-pending);\n    }\n  }\n\n  .calendar-event-title {\n    line-height: 14px;\n\n    &::part(text) {\n      text-transform: initial;\n    }\n  }\n\n  // Styles for intraday events\n  &.is-cutoff {\n    border-radius: 3px 3px 0 0;\n  }\n\n  &.is-ellipsis {\n    .calendar-event-content {\n      white-space: nowrap;\n    }\n  }\n\n  &.reduced-padding {\n    .calendar-event-content {\n      padding: 0 5px;\n    }\n\n    .calendar-event-title {\n      position: relative;\n      top: -1.6px;\n    }\n  }\n\n  .calendar-event-content {\n    padding: 2px 5px;\n  }\n}\n\n// All day event styles\n.ids-calendar-event.all-day {\n  top: 1px;\n\n  .calendar-event-time, \n  .calendar-event-comments {\n    display: none;\n  }\n\n  &.calendar-event-start,\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    border-radius: 0;\n  }\n\n  // first of multi day\n  &.calendar-event-start {\n    border-start-start-radius: 3px;\n    border-end-start-radius: 3px;\n  }\n\n  &.calendar-event-continue {\n    width: calc(100% + 2px);\n    margin-inline-start: -1px;\n  }\n\n  // end of multiday\n  &.calendar-event-ends {\n    border-end-end-radius: 3px;\n    border-start-end-radius: 3px;\n  }\n\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    ids-icon {\n      visibility: hidden;\n    }\n\n    .calendar-event-title {\n      color: var(--ids-color-transparent);\n    }\n  }\n}\n\n// Month View Styles\n.ids-calendar-event.is-month-view {\n  $month-margin: 5px;\n\n  position: absolute;\n  display: block;\n\n  &:not(.all-day) {\n    width: calc(100% - ($month-margin * 2));\n    margin: 0 $month-margin;\n  }\n\n  &.calendar-event-start,\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    width: calc(100% - $month-margin);\n  }\n\n  &.calendar-event-start {\n    margin-inline-start: $month-margin;\n  }\n\n  &.calendar-event-continue {\n    width: 100%;\n    margin-inline-start: 0;\n  }\n\n  &.calendar-event-ends {\n    margin-inline-end: $month-margin;\n  }\n\n  &.hidden {\n    display: none;\n  }\n\n  .calendar-event-content {\n    padding: 2px 4px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
